import React, { Fragment } from "react";
import { OrderCostSummaryV2Props } from "../index";
import Col from "../../../../../components/Common/Col";
import { formatCurrency } from "../../../../../utils/Format";
import { totalCost } from "../../../../../utils/Cost";
import Row from "../../../../../components/Common/Row";
import { OrderCategory, OrderStatus } from "../../../../../api/endpoints/Order";

const TotalCost = (props: OrderCostSummaryV2Props) => {
  const { cost, orderStatus, orderCategory, annualTotalCostFootnoteRef } = props;
  const { total_cost } = cost.data;

  if (!total_cost) {
    return null;
  }

  let label = 'Annual total cost';

  if (
    orderStatus === OrderStatus.DRAFT &&
    (orderCategory === OrderCategory.REALTIME || orderCategory === OrderCategory.EU_CUTOUT)
  ) {
    label = 'Total Annual Information Cost';
  }

  return (
    <Fragment>
      <Row className="total-cost">
        <Col sm={12} md={10}>
          <strong>{label}</strong>
          {annualTotalCostFootnoteRef && <sup>{annualTotalCostFootnoteRef}</sup>}
        </Col>
        <Col sm={12} md={2}>
          {
            formatCurrency(totalCost(cost))
          }
        </Col>
      </Row>
    </Fragment>
  )
}

export default TotalCost;
